import { HOURS_TO_MILLISECONDS, } from "ee-nestjs-interfaces";
import { LineGraph } from "ee-react-components";
import React from "react";
export var PowerNodeSocGraph = function (_a) {
    var dataPoints = _a.dataPoints;
    var isMultiDay = dataPoints.length >= 2 &&
        new Date(dataPoints[dataPoints.length - 1].timestamp).getTime() -
            new Date(dataPoints[0].timestamp).getTime() >
            24 * HOURS_TO_MILLISECONDS;
    var labelAccessor = function (d) {
        var date = new Date(d.timestamp);
        if (isMultiDay) {
            return date.toLocaleDateString([], {
                month: "numeric",
                day: "numeric",
            });
        }
        return date.toLocaleTimeString([], {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
    };
    var valueAccessors = [
        {
            label: "SOC",
            accessor: function (d) { return d.soc; },
        },
        {
            label: "Target SOC",
            accessor: function (d) { return d.targetSoc; },
            dashed: true,
            omitFill: true,
        },
    ];
    var tooltipAccessor = function (d) {
        var date = new Date(d.timestamp);
        if (isMultiDay) {
            return date.toLocaleString([], {
                month: "numeric",
                day: "numeric",
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
            });
        }
        return "".concat(date.toLocaleTimeString([], {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        }));
    };
    return (React.createElement(LineGraph, { showMouseTooltip: true, labelAccessor: labelAccessor, valueAccessors: valueAccessors, data: dataPoints, yAxisValueToLabel: function (v) { return "".concat(v.toFixed(1), "%"); }, tooltipLabelAccessor: tooltipAccessor, manualOrder: true, yAxisRange: { min: 0, max: 100 } }));
};
